import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Loader } from '@components/loader';

import { Container, Content } from './styled';

export const AuthLayout = () => {
  return (
    <Container>
      <Content>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Content>
    </Container>
  );
};
